import React, { memo, useCallback, useEffect, useState } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTurnList,
  cancelMineTurn,
  getGroupList,
  openGroup,
  setShowList,
} from '../../../actions/wallpaperPay';
import WallpaperCard from '../../../components/WallpaperCard/WallpaperCard';
import InfiniteScroll from 'react-infinite-scroller';
import TurnBlank from './TurnBlank';
import styles from './Turn.module.less';
import hint from '../../../static/wp_blank.png';
import { logging, logPostInfo } from '../../../actions/log';
import Empty from './Empty';
import InvalidTag from './InvalidTag';
import TurnControl from '../WallpaperComponents/TurnControl';
import GroupList from '../WallpaperComponents/GroupList';
import WallpaperGroup from '../../../components/WallpaperCard/WallpaperGroup';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectMineInfo = createSelector(
  state => {
    return state.wallpaperPay;
  },
  info => {
    return info.mineTurnInfo;
  },
);

const selectGroupList = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.openGroupList,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectVipState = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

const SelectShowList = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.loopTimeShow,
);

export default memo(({ node }) => {
  const userInfo = useSelector(selectUserInfo);
  const dispatch = useDispatch();
  const [showNumber, setShowNumber] = useState(3);
  const mineInfo = useSelector(selectMineInfo);
  const logInfoData = useSelector(selectLogInfo);
  const groupListTag = useSelector(selectGroupList);
  const vipState = useSelector(SelectVipState);
  const showList = useSelector(SelectShowList);

  const handleLogin = useCallback(() => {
    window.CallNativeMethod('logout');
    window.CallNativeMethod('login');
    // 点击 登录
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Login',
        label: '',
        param2: {
          source: `Wallpaper_Mine||setup`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch, logInfoData]);

  useEffect(() => {
    if (userInfo && userInfo.st) {
      dispatch(getTurnList({ pageCursor: '', refresh: true }));
      dispatch(getGroupList());
    }
  }, [userInfo, vipState]);

  // 监听轮播频率列表是否显示
  useEffect(() => {
    if (showList) {
      window.addEventListener('click', handleClose, false);
    }
    return () => {
      window.removeEventListener('click', handleClose);
    };
  }, [showList]);

  const handleClose = e => {
    if (e.target.className !== 'frequency_btn') {
      dispatch(setShowList(false));
    }
  };

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(3);
    } else if (clientWidth >= 1330 && clientWidth < 1465) {
      setShowNumber(4);
    } else if (clientWidth >= 1465 && clientWidth < 1600) {
      setShowNumber(4);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(5);
    } else if (clientWidth >= 1870) {
      setShowNumber(6);
    }
  }, []);

  const getClassType = useCallback(
    (index = 0, number = '3') => {
      const series = {
        '3': {
          big: [1],
          big_space: [2, 0],
        },
        '4': {
          big: [1],
          big_space: [2, 3, 0],
        },
        '5': {
          big: [1],
          big_space: [2, 3, 4, 0],
        },
        '6': {
          big: [1],
          big_space: [2, 3, 4, 5, 0],
        },
      };
      const pos = (index + 1) % parseInt(number);
      let classType = 'small';
      if (series[number].big && series[number].big.indexOf(pos) > -1) {
        classType = 'small';
      }
      if (series[number].big_space && series[number].big_space.indexOf(pos) > -1) {
        classType = 'small_space';
      }
      return classType;
    },
    [showNumber],
  );

  const loadMore = useCallback(() => {
    if (userInfo && userInfo.st) {
      dispatch(getTurnList({ pageCursor: mineInfo.pageCursor, refresh: false }));
    }
  }, [mineInfo]);

  const handleCancelTurn = parmas => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_LoopCancel_Mine',
        label: '',
        param2: {
          source: `Wallpaper_Mine||loop`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          classId: parmas?.contentId,
          wallpaperId: parmas?.wallpaperId ?? '',
          groupType: parmas?.groupType ?? 1,
        },
      }),
    );
    let obj = {};
    if (parmas.wallpaperId) {
      obj = mineInfo.list.find(item => item?.wallpaperInfo?.wallpaperId === parmas.wallpaperId);
    } else {
      obj = mineInfo.list.find(item => item.contentId === parmas.contentId);
    }

    if (obj.vaildType === 'vaild') {
      dispatch(getTurnList({ pageCursor: '', refresh: true }));
    } else {
      dispatch(
        cancelMineTurn({
          parmas,
        }),
      );
    }
  };

  return (
    <div className={`${!userInfo || (userInfo && !userInfo.st) ? '' : styles.wp_turn}`}>
      {userInfo &&
        userInfo.st &&
        (mineInfo?.validCarouselList?.length !== 0 ||
          mineInfo?.invalidCarouselList?.length !== 0) && (
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={mineInfo.hasNextPage === 1 ? true : false}
            loader={
              <div className="loader" key={0}>
                --加载中--
              </div>
            }
            initialLoad={!mineInfo.list.length}
            useWindow={false}
            getScrollParent={() => node}
          >
            {mineInfo?.validCarouselList?.length > 0 &&
              mineInfo?.validCarouselList?.map((item, index) => {
                if (item.groupType === '1') {
                  return (
                    <WallpaperCard
                      wallpaper={item.wallpaperInfo}
                      key={`${index}_${item.wallpaperInfo?.wallpaperId}`}
                      cardInfo={{
                        pageSource: 'mine',
                        pageTage: 'turn',
                        classType: getClassType(index, showNumber),
                        isCollect: true,
                        isWallpaper: true,
                        isPreview: true,
                        isDeleteColl: false,
                        isDeleteUsed: false,
                        isDeleteTurn: true,
                        isShowTurn: false,
                        allData: [...mineInfo.allData],
                        deleteTurnCallback: handleCancelTurn,
                      }}
                      logInfo={{ source: `Wallpaper_Mine||loop` }}
                    />
                  );
                } else if (item.groupType !== 1) {
                  return (
                    <WallpaperGroup
                      wallpaper={item}
                      key={`${index}`}
                      cardInfo={{
                        pageSource: 'mine',
                        pageTage: 'turn',
                        classType: getClassType(index, showNumber),
                        isCollect: false,
                        isWallpaper: false,
                        isPreview: false,
                        isDeleteColl: false,
                        isDeleteUsed: false,
                        isDeleteTurn: true,
                        deleteTurnCallback: handleCancelTurn,
                      }}
                      logInfo={{ source: `Wallpaper_Mine||loop` }}
                    />
                  );
                }
              })}

            {(mineInfo?.validCarouselList?.length === 0 || mineInfo?.validCarouselList === null) &&
              mineInfo?.invalidCarouselList?.length > 0 && <Empty />}

            {mineInfo?.invalidCarouselList?.length > 0 && (
              <>
                <InvalidTag />
                {mineInfo?.invalidCarouselList?.map((item, index) => {
                  if (item.groupType === '1') {
                    return (
                      <WallpaperCard
                        wallpaper={item.wallpaperInfo}
                        key={`${index}_${item.wallpaperInfo.wallpaperId}`}
                        cardInfo={{
                          pageSource: 'mine',
                          pageTage: 'turn',
                          classType: getClassType(index, showNumber),
                          isCollect: true,
                          isWallpaper: true,
                          isPreview: true,
                          isDeleteColl: false,
                          isDeleteUsed: false,
                          isDeleteTurn: true,
                          isShowTurn: false,
                          allData: [...mineInfo.allData],
                          deleteTurnCallback: handleCancelTurn,
                        }}
                        logInfo={{ source: `Wallpaper_Mine||loop` }}
                      />
                    );
                  } else if (item.groupType !== 1) {
                    return (
                      <WallpaperGroup
                        wallpaper={item}
                        key={`${index}`}
                        cardInfo={{
                          pageSource: 'mine',
                          pageTage: 'turn',
                          classType: getClassType(index, showNumber),
                          isCollect: false,
                          isWallpaper: false,
                          isPreview: false,
                          isDeleteColl: false,
                          isDeleteUsed: false,
                          isDeleteTurn: true,
                          deleteTurnCallback: handleCancelTurn,
                        }}
                        logInfo={{ source: `Wallpaper_Mine||loop` }}
                      />
                    );
                  }
                })}
              </>
            )}

            {/* {mineInfo.list.map((item, index) => {
            if (item.tag === 'valid') {
              VALID_TAG = 1;
              return <Empty key={index} />;
            } else if (item.tag === 'invalid') {
              INVALID_TAG = 1;
              return <InvalidTag key={index} />;
            } else if (item.groupType === '1') {
              return (
                <WallpaperCard
                  wallpaper={item.wallpaperInfo}
                  key={`${index}_${item.wallpaperInfo.wallpaperId}`}
                  cardInfo={{
                    pageSource: 'mine',
                    pageTage: 'turn',
                    // classType: getClassType(item.wpIndex, showNumber),
                    classType: getClassType(index, showNumber),
                    isCollect: true,
                    isWallpaper: true,
                    isPreview: true,
                    isDeleteColl: false,
                    isDeleteUsed: false,
                    isDeleteTurn: true,
                    isShowTurn: false,
                    allData: [...mineInfo.allData],
                    deleteTurnCallback: handleCancelTurn,
                  }}
                  logInfo={{ source: `Wallpaper_Mine||loop` }}
                />
              );
            } else if (item.groupType !== 1) {
              return (
                <WallpaperGroup
                  wallpaper={item}
                  key={`${index}`}
                  cardInfo={{
                    pageSource: 'mine',
                    pageTage: 'turn',
                    classType: getClassType(index, showNumber),
                    isCollect: false,
                    isWallpaper: false,
                    isPreview: false,
                    isDeleteColl: false,
                    isDeleteUsed: false,
                    isDeleteTurn: true,
                    deleteTurnCallback: handleCancelTurn,
                  }}
                  logInfo={{ source: `Wallpaper_Mine||loop` }}
                />
              );
            }
          })} */}
            {/* {mineInfo.hasNextPage === 0 &&
            (mineInfo?.validCarouselList?.length === 0 || mineInfo?.validCarouselList === null) &&
            (mineInfo?.invalidCarouselList?.length === 0 ||
              mineInfo?.invalidCarouselList === null) && <div className="loader">--到底啦--</div>} */}
            {mineInfo.hasNextPage === 0 && <div className="loader">--到底啦--</div>}
          </InfiniteScroll>
        )}
      {!userInfo ||
        (userInfo && !userInfo.st && (
          <div className={styles.nologin}>
            <div className={styles.blank}>
              <div className={styles.blank_img}>
                <img src={hint} alt="" className={styles.backColor} />
              </div>
              <div className={styles.text}>
                登录后，查看“ 壁纸轮播 ” <span onClick={handleLogin}>立即登录</span>
              </div>
            </div>
          </div>
        ))}
      {userInfo &&
        userInfo.st &&
        !mineInfo.hasNextPage &&
        (mineInfo?.validCarouselList?.length === 0 || mineInfo?.validCarouselList === null) &&
        (mineInfo?.invalidCarouselList?.length === 0 || mineInfo?.invalidCarouselList === null) && (
          <div className={styles.blank}>
            <TurnBlank load={mineInfo.load} />
          </div>
        )}
      <TurnControl />
      {groupListTag && <GroupList />}
      {/* <GroupList /> */}
    </div>
  );
});
